"use client";

import { useTranslations } from "next-intl";
import { Textarea } from "@/shared/ui/inputs/textarea";
import { RESPONSE_MESSAGE_MAX } from "../model/applications";

interface RespondMessageFieldProps {
  value: string;
  onChange: (value: string) => void;
}

/** Подпись к отклику или приглашению: пара слов о себе, необязательна (KAN-1355). */
export function RespondMessageField({ value, onChange }: RespondMessageFieldProps) {
  const t = useTranslations("LfgBoard");
  return (
    <div className="space-y-1.5">
      <h3 className="text-[11px] font-bold uppercase tracking-[1.2px] text-highlight">{t("respond.signature")}</h3>
      <Textarea
        rows={3}
        value={value}
        maxLength={RESPONSE_MESSAGE_MAX}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t("respond.placeholder")}
        aria-label={t("respond.signature")}
        className="min-h-[76px] resize-y text-[13px]"
      />
      <p className="text-right text-[11px] text-muted-foreground">{value.length} / {RESPONSE_MESSAGE_MAX}</p>
    </div>
  );
}
